import { snakeCase } from 'lodash';

export const getActionType = (actionName, moduleName = 'ACCOUNT_SETUP_V2') =>
  `${moduleName}/${snakeCase(actionName).toUpperCase()}`;

export const createActionCreator = actionName => payload => ({
  type: getActionType(actionName),
  ...payload,
});
